
<template>
  <div class="body">
    <div class="boxtitle">
      <div class="btitle">
        <span>语音读书区</span>
      </div>
      <div class="bbtn">
        <i class="el-icon-arrow-left"></i>
        <i class="el-icon-arrow-right"
           style="color:#0B8586"></i>
      </div>
    </div>
    <div class="box">
      <div class="item"
           :style="(index==0||index==1)?'border-top:0':''"
           v-for="(item,index) in 6"
           :key="index">
        <img class="bimg"
             src="https://cgp-resource.oss-cn-beijing.aliyuncs.com/Images/Reading/reader.jpg"
             alt="" />
        <div class="iright">
          <span class="btitle">以全科医生的职业发展为导向，打造最优质的全科医学教育数字平台</span>
          <div class="irbot">
            <span>主持人：张三</span>
            <span>2022/12/23</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
.body {
    width: 1200px;
    margin: 0 auto;
    .boxtitle {
        width: 100%;
        border-bottom: 1px solid #ddd;
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .btitle {
            display: inline-block;
            font-size: 26px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 26px;
            padding: 15px 0;
            border-bottom: 1px solid #000000;
        }
        .bbtn {
            font-size: 20px;
            i {
                margin-left: 15px;
                cursor: pointer;
            }
        }
    }
    .box {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .item {
            width: 575px;
            padding: 20px 0;
            border-top: 1px solid #eee;
            display: flex;
            .bimg {
                width: 156px;
                height: 88px;
                margin-right: 20px;
            }
            .iright {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .btitle {
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #404040;
                    line-height: 27px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .irbot {
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #bbbbbb;
                    line-height: 27px;
                    span {
                        margin-right: 40px;
                    }
                }
            }
        }
    }
}
</style>